/**
 * Funcionalidades dos cards de produto
 * Controle de quantidade e adicionar ao carrinho
 */

(function ($) {
  "use strict";

  $(document).ready(function () {
    // Controle de quantidade - diminuir
    $(document).on("click", ".card-qty-decrease", function (e) {
      e.preventDefault();
      e.stopPropagation();

      var $container = $(this).closest(".card-qty-controls");
      var $input = $container.find(".card-qty-input");
      var currentVal = parseInt($input.val()) || 1;
      var minVal = parseInt($input.attr("min")) || 1;

      if (currentVal > minVal) {
        $input.val(currentVal - 1);
      }
    });

    // Controle de quantidade - aumentar
    $(document).on("click", ".card-qty-increase", function (e) {
      e.preventDefault();
      e.stopPropagation();

      var $container = $(this).closest(".card-qty-controls");
      var $input = $container.find(".card-qty-input");
      var currentVal = parseInt($input.val()) || 1;
      var maxVal = parseInt($input.attr("max"));

      if (isNaN(maxVal) || maxVal <= 0) {
        maxVal = 9999;
      }

      if (currentVal < maxVal) {
        $input.val(currentVal + 1);
      }
    });

    // Adicionar ao carrinho
    $(document).on("click", ".card-add-to-cart", function (e) {
      e.preventDefault();
      e.stopPropagation();

      var $button = $(this);
      var productId = $button.data("product-id");
      var $card = $button.closest(".card-qty-controls").length
        ? $button.closest(".card-qty-controls").parent()
        : $button.parent();
      var $qtyInput = $card.find(".card-qty-input");
      var quantity = parseInt($qtyInput.val()) || 1;

      $button.prop("disabled", true).addClass("opacity-50");

      $.ajax({
        type: "POST",
        url: wc_add_to_cart_params.ajax_url,
        data: {
          action: "woocommerce_ajax_add_to_cart",
          product_id: productId,
          quantity: quantity,
        },
        success: function (response) {
          if (response.error && response.product_url) {
            window.location = response.product_url;
            return;
          }

          // Trigger event para atualizar carrinho
          $(document.body).trigger("added_to_cart", [
            response.fragments,
            response.cart_hash,
            $button,
          ]);

          // Remove o link "View Cart" que o WooCommerce adiciona automaticamente
          setTimeout(function () {
            $(".added_to_cart.wc-forward").remove();
          }, 10);

          // Reseta a quantidade para 1
          $qtyInput.val(1);

          // Aguarda um pouco para o carrinho atualizar e depois abre o cart-drawer
          setTimeout(function () {
            // Recarrega o conteúdo do cart-drawer
            if (typeof window.refreshCartDrawer === "function") {
              window.refreshCartDrawer();
            }

            // Abre o cart-drawer usando a função global do animations.js
            if (typeof window.openCartDrawer === "function") {
              window.openCartDrawer();
            }
          }, 300);

          $button.prop("disabled", false).removeClass("opacity-50");
        },
        error: function () {
          $button.prop("disabled", false).removeClass("opacity-50");
        },
      });
    });
  });
})(jQuery);
